// Zentrale Route-Konstanten – einmalig definieren, überall nutzen.
// Vermeidet Tippfehler in <Link to="..." /> und erleichtert spätere Umbenennungen.

export const ROUTES = {
  home: '/',
  impressum: '/impressum',
  datenschutz: '/datenschutz',
  danke: '/danke',
};

// Anker-IDs der Home-Page-Sections.
// Werden von <Navigation> als <Link to={`/#${SECTION.prozess}`}> genutzt.
export const SECTION = {
  prozess: 'prozess',
  kontakt: 'kontakt',
};
